import React from 'react';
import { useSelector } from 'react-redux';
import { StoreInterface } from '../../store/types';
import DE from './terms-and-conditions/DE';
import GB from './terms-and-conditions/GB';
import LegalPage from './resolveLegalPageComponent';
import useLegalDocument from './useLegalDocument';

export default function TermsAndConditions() {
  const { company } = useSelector((store: StoreInterface) => store.initialData);

  const { generated, isPending } = useLegalDocument('terms-and-conditions');

  return (
    <LegalPage
      bundles={{ de: DE, gb: GB }}
      legalPack={company?.region?.legal_pack}
      generated={generated}
      isPending={isPending}
    />
  );
}
